import React, { forwardRef } from 'react';
import { LayoutColors } from '@src/core/theme';
import { HelperText, InputArea, Label, Input } from './style';

interface CodeInputProps {
  label?: string;
  value?: string;
  name?: string;
  onChange: (code: string) => void;
  helperText?: React.ReactNode | string;
  error?: boolean;
  className?: string;
  length?: number;
}
export const CodeInput = forwardRef<HTMLInputElement, CodeInputProps>((props: CodeInputProps) => {
  const { label, value, onChange, helperText, error, className, name, length = 6 } = props;

  return (
    <InputArea className={className}>
      {label ? <Label htmlFor={props.name}>{label}</Label> : null}

      <Input
        value={value}
        name={name}
        onChange={onChange}
        autoFocus
        OTPLength={length}
        inputStyles={{
          width: '100%',
          height: '45px',
          padding: '0',
          margin: '0',
          borderRadius: '4px',
          border: `1px solid ${LayoutColors.blackLight}`,
          fontSize: '19px',
          fontWeight: 700,
          lineHeight: '23px',
          color: '#4D4D4D',
        }}
      />

      {helperText ? <HelperText $error={error ?? false}>{helperText}</HelperText> : null}
    </InputArea>
  );
});

CodeInput.displayName = 'CodeInput';

export default CodeInput;
